import styled from "styled-components";
import { media } from "../../../../../components/common/media";
import InquiryBG from "../../../../../images/inquiry-bg.jpg";
const MainContainer = styled.section`
  background: url(${InquiryBG}) left top no-repeat;
  overflow-x: hidden;
  ${media.desktop`
    background: #fff;
  `}
  .inquiry-newsletter {
    display: none;
    ${media.desktop`
      display: block;
    `}
  }
`;

export default MainContainer;
